export const LoansViewColumns = [
  'loanId',
  'loanName',
  'externalLoanId',
] as const;
